var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mp-steps-dots"},_vm._l((_vm.steps),function(step,$index){return _c('span',{key:$index,staticClass:"indicator-bullet",class:{
      active: $index === _vm.currentStepIndex,
      done: step.done,
      hide: step.hide,
    },on:{"click":function($event){return _vm.onStepSelect($index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }